// extracted by mini-css-extract-plugin
export var active = "_9w-d";
export var blink = "_9w-e";
export var container = "_9w-5";
export var controls = "_9w-0";
export var controlsRight = "_9w-1";
export var fakeCursor = "_9w-c";
export var hidden = "_9w-b";
export var quillContainerSmall = "_9w-7";
export var quillEditor = "_9w-6";
export var quillEditorSmall = "_9w-8";
export var quillFormatButtons = "_9w-a";
export var quillToolbar = "_9w-9";
export var removePadding = "_9w-2";
export var state = "_9w-3";
export var stateTitle = "_9w-4";